<template>
  <div class="pages">

    <!-- 移动端 -->
    <div :class="[ismobile ? '' : 'none']" class="img1">
      <div class="top">
        <img class="logo" v-if="status" src="../image/downloadImg_5.png" alt="">
        <img class="logo" v-else src="../image/downloadImg_5_1.png" alt="">
        <img class="text" src="../image/img1logotext.png" alt="">
      </div>
      <div class="center">
        <div class="nav" v-html="pro"> </div>
        <div class="pro first">
          <img src="../image/yellorou.png" alt="" srcset="">
          <p>查询进出口报关单主要业务信息、向税务总局发送报关单数据等特色功能</p>
        </div>
        <div class="pro ">
          <img src="../image/yellorou.png" alt="" srcset="">
          <p>通关业务状态查询与信息订阅推送等功能</p>
        </div>
        <div class="pro ">
          <img src="../image/yellorou.png" alt="" srcset="">
          <p>邮包、跨境电商消费额度等个人通关业务状态查询</p>
        </div>
        <div class="pro last">
          <img style="" src="../image/yellorou.png" alt="" srcset="">
          <p>金融保险、出口信用保险等专题查询服务</p>
        </div>
      </div>
      <!-- 如果是微信内置浏览器显示蒙板 -->
      <div class="mengban" :class="[ismobile && isweiXin ? '' : 'none']">
        <img src="../image/downloadImg_22.png" alt="">
      </div>
      <!-- 不是微信内置浏览器 -->
      <div class="bottom" :class="[downloads && !loading && !isweiXin ? '' : 'none']">
        <div>软件安装中，请在桌面查看</div>
        <div>内测软件，需手动设置信任证书</div>
        <div class="btn" @click="opentrust">
          立即前往
        </div>
      </div>
      <!-- 立即下载 -->
      <div class="bottoms" :class="[!downloads && !loading && !isweiXin ? '' : 'none']" @click="download" v-if="showDownStatus">
        <div class="btn">
          <img src="../image/downloadImg_23.png" alt="">
          立即下载
        </div>
      </div>
      <div class="bottoms" :class="[!downloads && !loading && !isweiXin ? '' : 'none']" v-if="showTipsStatus">
        <div class="btn">
          <img src="../image/downloadImg_23.png" alt="">
          敬请期待
        </div>
      </div>
      <!-- 动画 -->
      <div class="loading" :class="[ loading && !isweiXin ? '' : 'none']" @click="download">
        <img src="../image/loading.gif" alt="">
      </div>
    </div>

    <!-- 是pc端 -->
    <div :class="[!ismobile ? '' : 'none']" class="down-img3">
      <!-- <img src="../image/downloadImg_2.jpg" alt="" srcset=""> -->
      <div class="down-w1680">
        <div class="down-nav">
          <div class="down-nav-pic">
            <img v-if="status" src="../image/downloadImg_5.png" alt="">
            <img v-else src="../image/downloadImg_5_1.png" alt="">
          </div>
          <div class="down-nav-text">
            <img src="../image/navpci.png" alt="">
          </div>
        </div>
        <div class="down-left">
          <div class="qrcodeOut">
            <div id="qrcode"></div>
          </div>
          <p class="down-left-text">请使用手机扫描二维码 下载APP</p>
          <p style="left:34%" class="down-left-login" @click="login">APP登录</p>
          <p style="left:60%" class="down-left-instructions" @click="OpenInstructions">《使用说明》</p>
        </div>
        <div class="down-right">
          <img class="down-right-bg" src="../image/testbg.png" alt="">
          <p class="down-right-p1" v-html="pro"> </p>
          <div class="down-right-p2-flex down-right-pos1">
            <img class="down-ye" src="../image/yellorou.png" alt="" srcset="">
            <p>查询进出口报关单主要业务信息、向税务总局发送报关单数据等特色功能</p>
          </div>
          <div class="down-right-p2-flex down-right-pos2">
            <img class="down-ye" src="../image/yellorou.png" alt="" srcset="">
            <p>通关业务状态查询与信息订阅推送等功能</p>
          </div>
          <div class="down-right-p2-flex down-right-pos3">
            <img class="down-ye" src="../image/yellorou.png" alt="" srcset="">
            <p>邮包、跨境电商消费额度等个人通关业务状态查询</p>
          </div>
          <div class="down-right-p2-flex down-right-pos4">
            <img class="down-ye" src="../image/yellorou.png" alt="" srcset="">
            <p>金融保险、出口信用保险等专题查询服务</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import QRCode from "qrcodejs2";
import { Sticky } from "vant";

import sdk from "@/views/js/sdk";
import "@/views/css/download.scss";
export default {
  name: "downloadapp",
  components: {
    [Sticky.name]: Sticky,
  },

  data() {
    return {
      height: window.innerHeight / 37.5,
      status: false, //判断是正式环境还是测试环境
      loading: false, //判断是否显示动画
      isandriod: false, //判断是andriod还是ios
      ismobile: false, //判断是移动端还是pc端
      isweiXin: false, //判断是否是微信内置浏览器
      downloads: false, //ios判断段是否点击下载
      retData: {},
      showDownStatus: true,
      showTipsStatus: false,
      pro:
        "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp为广大进出口企业或个人提供国际贸易“一站式”业务查询和办理服务，实时掌握通关状态、随时随地办理业务，提高办事效率。",
    };
  },
  /**
   * 初始化
   */
  mounted() {
    console.log(document.body.clientWidth * document.body.clientHeight * 2);
    console.log(navigator.userAgent);
    //是ios还是andriod
    const u = navigator.userAgent;
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    //是否是移动端
    if (this.isMobile()) {
      if (isiOS) {
        this.isandriod = false;
      } else {
        this.isandriod = true;
        window.location.href = "asinglewindow://"; //安卓直跳app
      }
      this.ismobile = true;
    } else {
      this.ismobile = false;
    }
    // 是否是微信内置浏览器
    if (this.isWeiXin()) {
      this.isweiXin = true;
      //微信分享
      let url = location.href.split("#")[0];
      url = url.replace("/#/", "/?#/");
      let linkurl = location.href;
      this.judge();
      if (this.status) {
        //微信分享需要的参数
        var dataForWeixin = {
          //分享标题
          title: "掌上单一窗口下载页",
          //分享内容
          desc:
            "“掌上单一窗口”是“中国国际贸易单一窗口”标准版在移动的统一查询和办事的公共…",
          //分享链接
          linkurl: linkurl,
          //分享内容显示的图片(图片必须是正方形的链接)
          img:
            "https://app.singlewindow.cn/zsdyckserver/myapp/dist/img/downloadImg_5.26266ea1.png",
        };
      } else {
        var dataForWeixin = {
          //分享标题
          title: "掌上单一窗口(测试版)下载页",
          //分享内容
          desc:
            "“掌上单一窗口”是“中国国际贸易单一窗口”标准版在移动的统一查询和办事的公共…",
          //分享链接
          linkurl: linkurl,
          //分享内容显示的图片(图片必须是正方形的链接)
          img:
            "https://apptest.singlewindow.cn/zsdyckserver/myapp/dist/img/downloadImg_5_1.d6e745d5.png",
        };
      }

      //传入微信分享需要的参数
      sdk.getJSSDK(url, dataForWeixin);
    } else {
      this.isweiXin = false;
    }

    this.qrcode();
    this.getData();
    this.judge();
    window.addEventListener("resize", () => {
      this.qrcode();
      this.height = window.innerHeight;
    });
    if (this.status) {
      var style =
        "@import url(https://app.singlewindow.cn/zsdyckweb/pccss/download.css);";
    } else {
      var style =
        "@import url(https://apptest.singlewindow.cn/zsdyckweb/pccss/download.css);";
    }

    var ele = document.createElement("style");
    ele.innerHTML = style;
    document.getElementsByTagName("head")[0].appendChild(ele);
  },

  methods: {
    login() {
      let stamp = new Date().getTime();
      if (this.status) {
        let Instructions =
          "https://app.singlewindow.cn/zswebserver/authpc/mobileTerminal.html?nocache=" +
          stamp;
        window.open(Instructions, "_blank");
      } else {
        let Instructions =
          "https://apptest.singlewindow.cn/zswebserver/authpc/mobileTerminal.html?nocache=" +
          stamp;
        window.open(Instructions, "_blank");
      }
    },
    OpenInstructions() {
      if (this.status) {
        let Instructions =
          "http://update.singlewindow.cn/appDownload/zsdyck-instruction.pdf";
        window.open(Instructions, "_blank");
      } else {
        let Instructions =
          "http://apptest.singlewindow.cn/appDownload/zsdyck-instruction.pdf";
        window.open(Instructions, "_blank");
      }
    },
    //判断当前是正式域名还是测试域名
    judge() {
      let str = window.location.href;
      let index = str.indexOf("app.singlewindow.cn");
      let index1 = str.indexOf("swapp.singlewindow.cn");
      let index2 = str.indexOf("apptrain.singlewindow.cn");
      if (index > -1 || index1 > -1 || index2 > -1) {
        this.status = true;
        if (!this.isandriod) {
          //ios 正式环境 现在为立即下载
          this.showDownStatus = true;
          this.showTipsStatus = false;
        }
      } else {
        this.status = false;
      }
    },
    //获取页面下载所需数据
    getData() {
      this.$http1.get("/zsdyckserver/app/getAppVer", {}).then((res) => {
        this.retData = res.retData;
      });
    },
    //ios受信任
    opentrust() {
      window.location.href =
        this.retData.IOS_DOWNLOAD + "embedded.mobileprovision";
    },
    //点击下载
    download() {
      this.loading = true;
      if (this.isandriod) {
        window.location.href = "asinglewindow://"; //安卓直跳app
        window.location.href = this.retData.AN_URL;
      } else {
        if (this.status) {
          // window.location.href = "https://apps.apple.com/cn/app/id1546059024"; //填下载App落地页
          window.location.href = this.retData.IOS_URL; //填下载App落地页
        } else {
          window.location.href = "asinglewindow://"; //ios直跳app
          window.location.href =
            "itms-services://?action=download-manifest&url=" +
            this.retData.IOS_DOWNLOAD +
            "zsdyck.plist";
          setTimeout(() => {
            this.downloads = true;
            this.loading = false;
          }, 3200);
        }
      }
    },
    // 判断是移动端还是pc端
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    //判断是否是微信内置浏览器
    isWeiXin() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true; // 是微信端
      } else {
        return false;
      }
    },
    //生成二维码(pc端)
    qrcode() {
      document.getElementById("qrcode").innerHTML = "";

      let width = 320;
      let height = 320;
      let qrcode = new QRCode("qrcode", {
        width: width,
        height: height,
        colorDark: "#000",
        colorLight: "#fff",
        typeNumber: 4,
        correctLevel: QRCode.CorrectLevel.H,
      });
      qrcode.clear(); //清除二维码
      qrcode.makeCode(window.location.href);
    },
  },
};
</script>

<style scoped lang="scss">
//@import "https://appcs.singlewindow.cn/zsdyckweb/download.css";

.pages {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  //position: relative;
}
.img1 {
  //position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 375px;
  height: 720px;
  // height: 100vh;
  background: url("../image/downloadImg_21.jpg") no-repeat;
  // border: 1px solid red;
  background-size: 100% 100%;
  box-sizing: border-box;
  padding-top: 50px;
  .top {
    display: flex;
    flex-direction: row;
    > .logo {
      width: 60px;
      height: 60px;
      margin-left: 70px;
      display: block;
    }
    > .text {
      margin-top: 14px;
      margin-left: 18px;
      // width: 150px;
      height: 36px;
    }
  }
  .center {
    background: url("../image/img1bg.png") no-repeat;
    background-size: 100% 100%;

    width: 261px;
    height: 267px;
    margin: 0 auto;
    padding-top: 13px;
    margin-top: 39px;
    .nav {
      // height: 20vh;

      margin-left: 15px;
      margin-right: 35px;
      font-size: 15px;
      line-height: 20px;
      color: #0a3458;
      margin-bottom: 5px;
    }
    .pro {
      margin-left: 8px;
      margin-right: 12px;
      margin-bottom: 11px;
      display: flex;
      flex-direction: row;
      img {
        width: 10px;
        height: 10px;
        margin-top: 0px;
      }
      p {
        font-weight: 600;
        margin-left: 6px;
        font-size: 12px;
        line-height: 13px;
        color: #053a71;
      }
    }
    .first {
      margin-top: 4vh;
    }
    .last {
      margin-bottom: 7vh;
    }
  }
  .mengban {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100vh;
    background: rgba($color: #040b1d, $alpha: 0.8);
    img {
      width: 100%;
    }
  }
  .bottom {
    width: 100%;
    margin-top: 40px;
    // bottom: 41px;
    > div:first-child {
      text-align: center;
      color: #ff7f00;
      font-size: 16px;
      font-weight: 600;
    }
    > div:nth-child(2) {
      text-align: center;
      color: #050f28;
      font-size: 10px;
      margin-top: 10px;
    }
    .btn {
      width: 158px;
      height: 50px;
      line-height: 50px;
      margin: auto;
      margin-top: 20px;
      text-align: center;
      background: rgba(255, 127, 0, 1);
      border-radius: 25px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(254, 254, 254, 1);
    }
  }
  .bottoms {
    width: 100%;

    margin-top: 80px;
    .btn {
      width: 158px;
      height: 50px;
      line-height: 50px;
      margin: auto;
      margin-top: 20px;
      background: rgba(255, 127, 0, 1);
      border-radius: 25px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(254, 254, 254, 1);
      img {
        width: 20px;
        height: 18px;
        float: left;
        margin: 18px 10px 0 35px;
      }
    }
  }
  .loading {
    width: 100%;
    margin-top: 40px;
    img {
      margin: auto;
      display: block;
      width: 48px;
      height: 48px;
    }
  }
}

.down-img3 {
  width: 100%;
  height: 100%;
  background: url("../image/downloadImg_2.jpg") no-repeat;
  background-position: center;
  background-size: cover;
}

.none {
  display: none;
}
</style>